// src/pages/Capabilitymatters.js
import React from 'react';

const Capabilitymatters = () => {
  return (
    <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
      <h1>Stop Paying for What You Should Know</h1>

      <p>
        It's surprising how companies hamstring themselves by failing to develop core competencies in-house.
      </p>

      <p>
        Outsourcing what should be internal capability is a classic mistake. When executives lack technical understanding, they're vulnerable to vendor promises and inflated costs.
      </p>

      <p>
        That $100k-quality flythrough we needed? After a few teaching sessions, one of our grads built it in Twinmotion. Since then, we've handled all visualisations in-house. Turns out, upskilling the team often beats outsourcing—it's cheaper and the capability stays with you.
      </p>

      <p>
        Technical leadership without technical experience creates an <strong>accountability gap</strong>. They can’t effectively question proposals or spot padded estimates. This isn't about doing everything internally—it's about knowing enough to make smart build-vs-buy decisions.
      </p>

      <p>
        The most successful companies will often maintain strong in-house capabilities. This builds <strong>institutional knowledge</strong>, enables rapid iteration, and avoids dependency on vendors who rarely share your priorities.
      </p>

      <p>
        Smart organisations invest in growing these capabilities, instead of paying the ongoing <em>"ignorance tax"</em> on outsourced solutions which often cost more and deliver less.
      </p>
    </main>
  );
};

export default Capabilitymatters;
